import { IPoint } from '../consts/types';

export default (angle: number): IPoint => {
  const angleInRadian = angle/180 * Math.PI;
  return {
    x: Math.cos(angleInRadian),
    y: Math.sin(angleInRadian)
  }
}